// Fixed film-grain overlay for a raw, cinematic texture.
export default function Grain() {
  return <div className="grain-overlay" aria-hidden="true" />;
}
